import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { SEO, breadcrumbLd } from "@/lib/seo";
import { api } from "@/lib/api";
import Reveal from "@/components/Reveal";

const CATEGORIES = ["Wszystkie", "Poradnik", "Trendy"];

const Blog = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cat, setCat] = useState("Wszystkie");

  useEffect(() => {
    api.get("/posts").then((r) => setPosts(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const shown = posts.filter((p) => cat === "Wszystkie" || p.category === cat);

  return (
    <>
      <SEO
        title="Poradnik brukarski – blog | AD Brikman Łęczna, Lublin, Świdnik"
        description="Poradnik brukarski AD Brikman: jaka kostka na podjazd, budowa podjazdu krok po kroku, impregnacja kostki, trendy w kostce brukowej. Łęczna, Lublin, Świdnik i okolice."
        path="/blog"
        jsonLd={breadcrumbLd([{ label: "Strona główna", path: "/" }, { label: "Blog", path: "/blog" }])}
      />

      <section className="grain relative overflow-hidden bg-ink pt-36 pb-16 lg:pt-44">
        <div className="paver-bg absolute inset-0 opacity-60" />
        <div className="relative mx-auto max-w-7xl px-4 sm:px-8">
          <Reveal>
            <p className="eyebrow mb-5">Blog · Poradnik</p>
          </Reveal>
          <Reveal delay={0.05}>
            <h1 className="font-display max-w-4xl text-5xl font-black uppercase leading-[0.95] tracking-tight text-pearl sm:text-7xl" data-testid="blog-title">
              Wiedza <span className="text-amber">z budowy</span>
            </h1>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 max-w-2xl text-base leading-relaxed text-stonemute">
              Praktyczne porady brukarskie — jak dobrać kostkę, jak przebiega budowa i jak dbać o nawierzchnię.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-8 lg:py-24" data-testid="blog-list">
        <div className="mb-10 flex flex-wrap gap-3">
          {CATEGORIES.map((c) => (
            <button
              key={c}
              onClick={() => setCat(c)}
              data-testid={`blog-filter-${c.toLowerCase()}`}
              className={`notch-sm px-5 py-2.5 font-mono text-[11px] uppercase tracking-[0.2em] transition-colors duration-300 ${cat === c ? "bg-amber text-ink" : "border border-white/10 bg-graph text-stonemute hover:text-pearl"}`}
            >
              {c}
            </button>
          ))}
        </div>

        {loading && <p className="text-stonemute">Wczytywanie wpisów…</p>}

        {!loading && shown.length === 0 && (
          <p className="text-stonemute" data-testid="blog-empty">Brak wpisów w tej kategorii.</p>
        )}

        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {shown.map((p, i) => (
            <Reveal key={p.slug} delay={(i % 3) * 0.08}>
              <Link to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`} className="card-edge group flex h-full flex-col overflow-hidden">
                {p.cover && <img src={p.cover} alt={p.title} loading="lazy" className="h-48 w-full object-cover opacity-80 transition-transform duration-700 group-hover:scale-105" />}
                <div className="flex flex-1 flex-col p-6">
                  <p className="eyebrow mb-3">{p.category}</p>
                  <h2 className="font-display text-xl font-bold uppercase leading-snug text-pearl transition-colors duration-300 group-hover:text-amber">{p.title}</h2>
                  <p className="mt-3 flex-1 text-sm leading-relaxed text-stonemute">{p.excerpt}</p>
                  <span className="mt-5 font-mono text-[11px] uppercase tracking-[0.2em] text-amber">
                    {p.published_at ? new Date(p.published_at).toLocaleDateString("pl-PL", { day: "numeric", month: "long", year: "numeric" }) : ""}
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
};

export default Blog;
